import { render, staticRenderFns } from "./CreateConsignmentNotesRegistry.vue?vue&type=template&id=41bd7bc9&"
import script from "./CreateConsignmentNotesRegistry.vue?vue&type=script&lang=js&"
export * from "./CreateConsignmentNotesRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports